import http from "../utils/http-common";

class AoAnDataService {
  getAll() {
    return http.get("/ao-an");
  }

  getAllActive() {
    return http.get("/ao-an/active");
  }

  getByValidFromAndType(valid_from, type) {
    return http.get(`/ao-an/${valid_from}/${type}`);
  }

  get(id) {
    return http.get(`/ao-an/${id}`);
  }

  create(data) {
    return http.post("/ao-an", data);
  }

  update(valid_from, type, data) {
    return http.put(`/ao-an/${valid_from}/${type}`, data);
  }

  delete(valid_from, type) {
    return http.delete(`/ao-an/${valid_from}/${type}`);
  }

  deleteByValidFrom(valid_from) {
    return http.delete(`/ao-an/by-date/${valid_from}`);
  }
}

export default new AoAnDataService();
